import { Avatar } from "@mui/material";
import React from "react";
import ZaloPhoneLink from "../../../components/ZaloPhoneLink";
import Info from "../../../components/Info";

export default function BasicInfo({ customer }) {
  return (
    <div className="customer-info-section">
      <Avatar
        className="customer-avatar"
        sx={{ width: 100, height: 100 }}
        src={customer.image ? `/images/${customer.image}` : ""}
        alt={customer.name}
      />
      <div>
        <h1 className="customer-name">
          {customer.name ? customer.name : "No name"}
        </h1>
        <div style={{ display: "flex", gap: "1.5rem" }}>
          <ZaloPhoneLink value={customer.phone} />
          {customer.phone2 && <ZaloPhoneLink value={customer.phone2} />}
        </div>
        <div className="mt-3">
          <Info title="Address" body={customer.address} />
        </div>
      </div>
    </div>
  );
}